import { debounce } from "../../utilities/functions";

import { Base } from "./Base";

import Swiper from "swiper";

const classes = {
  center: "center",
  disabled: "disabled",
  pagination: "swiper-pagination",
};

const configurations = {
  "power-step": {
    slidesPerView: 2,
    pagination: {
      el: "." + classes.pagination,
      clickable: true,
    },
  },
};

export class Carousel extends Base {
  constructor(behaviorName, element) {
    super(behaviorName, element);

    const configuration = this.element.dataset.configuration;

    this.convention = {
      slidesPerView: "auto",
      watchOverflow: true,
      ...configurations[configuration],
    };

    this.swiper = {};
    this.center = false;
    this.init();
  }

  init() {
    this.initiateSwiper();
    this.handleNavigation();
    this.bindResizeHandlers();
  }

  initiateSwiper() {
    const { center } = this.element.dataset;

    this.swiper = new Swiper(this.element, this.convention);

    this.swiper.on("slideChangeTransitionEnd", () => {
      this.updateNavigationStatus();
    });

    this.updateNavigationStatus();

    if (center) {
      this.center = true;
      this.updateCenterStatus();
    }

    // Resize event to ensure Swiper behaving as expected
    // In particular the mobile version of the overlay carousel
    // doesn't seem to be calculating the correct width until
    // after resize...
    // With Polyfill
    setTimeout(() => {
      let event;

      if (typeof Event === "function") {
        event = new Event("resize");
      } else {
        event = document.createEvent("Event");
        event.initEvent("resize", true, true);
      }

      window.dispatchEvent(event);
    }, 1);
  }

  handleNavigation() {
    const { next, prev } = this.refs;

    if (next) {
      next.addEventListener("click", (e) => {
        e.preventDefault();

        if (this.swiper && !next.classList.contains(classes.disabled)) {
          this.swiper.slideNext();
        }
      });
    }

    if (prev) {
      prev.addEventListener("click", (e) => {
        e.preventDefault();

        if (this.swiper && !prev.classList.contains(classes.disabled)) {
          this.swiper.slidePrev();
        }
      });
    }
  }

  bindResizeHandlers() {
    this.resizeHandler = debounce(() => {
      this.updateNavigationStatus();
    }, 250);

    window.addEventListener("resize", this.resizeHandler);

    if (this.center) {
      this.resizeHandlerCenter = debounce(() => {
        this.updateCenterStatus();
      }, 250);

      window.addEventListener("resize", this.resizeHandlerCenter);
    }
  }

  updateNavigationStatus() {
    const { next, prev } = this.refs;

    if (this.swiper) {
      if (next) {
        if (this.swiper.isEnd) {
          next.classList.add(classes.disabled);
        } else {
          next.classList.remove(classes.disabled);
        }
      }

      if (prev) {
        if (this.swiper.isBeginning) {
          prev.classList.add(classes.disabled);
        } else {
          prev.classList.remove(classes.disabled);
        }
      }
    }
  }

  updateCenterStatus() {
    if (this.swiper.isBeginning && this.swiper.isEnd) {
      this.element.classList.add(classes.center);
    } else {
      this.element.classList.remove(classes.center);
    }
  }

  cleanup() {
    this.swiper.destroy(true, true);
    window.removeEventListener("resize", this.resizeHandler);

    if (this.center) {
      window.removeEventListener("resize", this.resizeHandlerCenter);
    }
  }
}
